import Options from "./Options";

const GeneralOptions = (props) => {
  const options = [

    {
      name: "Product Overview",
      handler: props.actionProvider.handleProductOverview,
      id: 1
    },
    {
      name: "Features",
      handler: props.actionProvider.handleFeatures,
      id: 2
    },
    {
      name: "For Schools",
      handler: props.actionProvider.handleForSchools,
      id: 3
    },
    {
      name: "Support",
      handler: props.actionProvider.handleContact,
      id: 4
    },
    {
      name: "Book a Demo",
      handler: props.actionProvider.handleBookDemo,
      id: 5
    },
  
 
  ];
  return <Options options={options} title="Options" {...props} />;
};

export default GeneralOptions;
